// src/js/modules/copy-rss.js

// La función ahora no toma argumentos. Se encarga de encontrar todo por sí misma.
export default function initCopyRss() {
  // 1. Buscamos TODOS los contenedores de copia en la página.
  const copyContainers = document.querySelectorAll(".js-copy-container");

  // Si no hay ninguno, no hacemos nada.
  if (copyContainers.length === 0) {
    return;
  }

  // 2. Definimos la URL del feed una sola vez.
  const rssUrl = `${window.location.origin}/feed.xml`;

  // 3. Iteramos sobre CADA contenedor que hemos encontrado.
  copyContainers.forEach((container) => {
    // 4. Buscamos el botón y el feedback DENTRO de cada contenedor.
    const copyButton = container.querySelector("[data-copy-button]");
    const feedbackElement = container.querySelector("[data-copy-feedback]");

    // 5. Si encontramos ambos, les asignamos la funcionalidad.
    if (copyButton && feedbackElement) {
      copyButton.addEventListener("click", () => {
        navigator.clipboard
          .writeText(rssUrl)
          .then(() => {
            feedbackElement.textContent = "¡Enlace copiado!";
            feedbackElement.classList.add("is-visible");
            copyButton.textContent = "¡Copiado!"; // Opcional: Cambiar texto del botón

            setTimeout(() => {
              feedbackElement.classList.remove("is-visible");
              copyButton.textContent = "Copiar Enlace del Feed"; // Opcional: Restaurar texto
            }, 2500);
          })
          .catch((err) => {
            feedbackElement.textContent = "No se pudo copiar";
            console.error("Error al copiar la URL del RSS: ", err);
          });
      });
    }
  });
}
